import React from 'react';
import PropTypes from 'prop-types';

const getClassName = (name) => {
  switch (name) {
    case 'Platform':
      return 'policy-primary';
    case 'Professional':
      return 'policy-secondary';
    case 'Executive':
      return 'policy-tertiary-400';
    case 'Enterprise':
      return 'policy-tertiary-1000';
    default:
      return '';
  }
};

export default function PolicyIcon({ plan }) {
  return (
    <div className={`policy-tile ${getClassName(plan.attributes.policy_template_name)}`}>
      <div className="icon" />
    </div>
  );
}

PolicyIcon.propTypes = {
  plan: PropTypes.object.isRequired,
};
